import type { PrivilegeModel } from '../models.ts'
import { AllPermissions } from '../types/permissions.ts'

export const CorePrivilege: PrivilegeModel = {
  name: 'Core',
  key: 'core',
  permissions: [
    'activity:create',
    'activity:view',
    'file:upload',
    'project:view',
    'own-team-profile:update',
  ],
}

export const OrganizationAdminPrivilege: PrivilegeModel = {
  name: 'Organization Admin',
  key: 'organization-admin',
  permissions: [
    'own-organization:administer',
    'own-organization-team:administer',
    'own-organization-user:administer',
    'own-team:administer',
    'own-team-user:administer',
  ],
}

export const BrandPrivilege: PrivilegeModel = {
  name: 'Brand',
  key: 'brand',
  permissions: [
    'cost-plus-margin:view',
    'internal-pricing-note:view',
    'project:archive',
    'project:comment',
    'project:create',
    'project:delete',
    'project:edit',
    'project:submit',
    'review-feedback:update',
    'brand:view',
    'package:view',
  ],
}

export const AgencyPrivilege: PrivilegeModel = {
  name: 'Agency',
  key: 'agency',
  permissions: [
    'bid:create',
    'cost:view',
    'offer:accept',
    'offer:decline',
    'offer:view',
    'project:comment',
    'project:complete',
    'review-proposal:update',
    'agency:edit',
    'agency:view',
  ],
}

export const InternalPrivilege: PrivilegeModel = {
  name: 'Internal',
  key: 'internal',
  permissions: [
    'cost:view',
    'cost-plus-margin:view',
    'internal-pricing-note:view',
    'offer:view',
    'package:administer',
    'package:view',
    'project:administer',
    'project:create',
    'project:complete',
    'project:edit',
    'project:submit',
    'watch:administer',
    'match:edit',
    'match:remove',
    'match:view',
    'customer-organization:administer',
    'customer-team:administer',
    'customer-user:administer',
    'agency:edit',
    'agency:view',
    'brand:view',
  ],
}

export const AllPrivilege: PrivilegeModel = {
  name: 'All',
  key: 'all',
  permissions: AllPermissions,
}

export const AllPrivileges = [
  CorePrivilege,
  AgencyPrivilege,
  BrandPrivilege,
  InternalPrivilege,
  AllPrivilege,
]
